import { HttpAdapter } from "../main/adapters/HttpAdapter";

export class DataCommunication {
    HttpAdapter = new HttpAdapter();
    baseUrlChatSession = `${publicSettings.aws.baseUrls.dataCommunications}/data-communications/chat-session`;

    async getChatSessionByUser({
        limit,
        page,
        type,
        contextId,
        companyId,
        userId
    }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlChatSession}/get-by-user`,
                {
                    limit,
                    page,
                    type,
                    contextId,
                    companyId,
                    userId,
                    type: "dashboard"
                }
            );
            return response;
        } catch (error) {
            console.error(error);
            return {
                mensages: [],
                total: 0
            };
        }
    }

    async getChatSessionSummaryByUser({ contextId }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlChatSession}/get-summary-by-user`,
                {
                    contextId
                }
            );
            return response;
        } catch (error) {
            return {
                mensages: [],
                total: 0
            };
        }
    }

    async removeChatSessionByUser({ companyId, userId, contextId }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlChatSession}/remove-by-user`,
                {
                    companyId,
                    userId,
                    contextId,
                    type: "dashboard"
                }
            );
            return response;
        } catch (error) {
            throw new Error(`Erro ao remover sessão de chat: ${error.message}`);
        }
    }

    async replyToUser({
        companyId,
        conversationId,
        userId,
        message,
        isSummary,
        isInsightKpi,
        contextId,
        options = {
            visualizationsIds: [],
            period: "",
            scenarioId: "",
            dates: [],
            accountingId: "",
            options: {
                isGroup: false,
                projection: {
                    totalMonths: 0,
                    scenarioId: ""
                },
                goalsIds: [],
                budget: {
                    scenarioId: ""
                }
            }
        }
    }) {
        try {
            const response = await this.HttpAdapter.call(
                "https://kifjikrsdsjhxlalrz7obrxvoy0jludy.lambda-url.us-east-1.on.aws",
                {
                    companyId,
                    conversationId,
                    userId,
                    message,
                    isSummary,
                    isInsightKpi,
                    contextId,
                    options,
                    type: "dashboard"
                }
            );
            return response;
        } catch (error) {
            console.error(error);
            return {
                conversationId: null,
                message: error.data || error.message || error
            };
        }
    }

    async explanation({
        companyId,
        type,
        options = {
            visualizationsIds: [],
            period: "",
            scenarioId: "",
            dates: [],
            accountingId: "",
            options: {
                isGroup: false,
                projection: {
                    totalMonths: 0,
                    scenarioId: ""
                },
                goalsIds: [],
                budget: {
                    scenarioId: ""
                }
            }
        }
    }) {
        try {
            const response = await this.HttpAdapter.call(
                "https://nxoiheov6qkfv7ietmuoglrdsy0lkqzk.lambda-url.us-east-1.on.aws",
                {
                    companyId,
                    type,
                    options
                }
            );
            return response;
        } catch (error) {
            console.error(error);
            return {
                conversationId: null,
                message: error.data || error.message || error
            };
        }
    }
}
